const alertMessages = {
    adicionar: 'Operação concluída com sucesso!',
    excluir: 'Item removido com sucesso!',
    editar: 'Alterações salvas com sucesso!',
    info: 'Complete as informações e tente novamente.',
    envio: 'Enviado com sucesso. Aguarde.',
    erro: 'Erro inesperado. Tente novamente.',
    erroEditar: 'Falha ao salvar alterações.',
    erroExcluir: 'Falha ao remover item.',
    nenhumaAlteracao: 'Nenhuma alteração detectada.'
};

export default alertMessages;
